/* Garden Storage — theme JS
   Minimal, no framework. Progressive enhancement only.
   Build budget: <50KB gzipped. */

(function () {
  'use strict';

  // ========== Mega-menu ==========
  var MM_MARGIN = 12; // min gap from the viewport edge

  function clampMegamenu(panel, trigger) {
    // Position is derived from the trigger's geometry and the panel's own width,
    // NOT from measuring the panel after un-hiding it. Reading the panel's rect in
    // the same frame it becomes visible can return the pre-transform position, which
    // made the clamp think a panel was on-screen when it was about to render off it.
    var inner = panel.querySelector('.megamenu__inner') || panel;
    var li = trigger.parentElement;
    var vw = document.documentElement.clientWidth;
    var w = panel.offsetWidth || 680;
    var liRect = li.getBoundingClientRect();
    var centre = liRect.left + (liRect.width / 2);
    var intendedLeft = centre - (w / 2);          // where translateX(-50%) lands it
    var shift = 0;
    if (intendedLeft < MM_MARGIN) {
      shift = MM_MARGIN - intendedLeft;
    } else if (intendedLeft + w > vw - MM_MARGIN) {
      shift = (vw - MM_MARGIN) - (intendedLeft + w);
    }

    if (shift) {
      panel.style.transform = 'translateX(calc(-50% + ' + Math.round(shift) + 'px))';
      // Move the arrow the opposite way so it still points at the nav item.
      var arrowLeft = (w / 2) - shift;
      arrowLeft = Math.max(20, Math.min(w - 20, arrowLeft));
      inner.style.setProperty('--mm-arrow', Math.round(arrowLeft) + 'px');
    } else {
      panel.style.transform = 'translateX(-50%)';
      inner.style.removeProperty('--mm-arrow');
    }
  }


  document.querySelectorAll('[data-megamenu-trigger]').forEach(function (trigger) {
    var idx = trigger.getAttribute('data-megamenu-trigger');
    var panel = document.querySelector('[data-megamenu="' + idx + '"]');
    if (!panel) return;
    var parent = trigger.parentElement;
    function open() {
      panel.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      clampMegamenu(panel, trigger);
    }
    function close() { panel.hidden = true; trigger.setAttribute('aria-expanded', 'false'); }
    parent.addEventListener('mouseenter', open);
    parent.addEventListener('mouseleave', close);
    trigger.addEventListener('focus', open);
    trigger.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(); trigger.blur(); } });
  });

  // ========== Delivery date ==========
  // Calculates "Free delivery Wed 4 May – Fri 6 May" from data-delivery-min/max
  // Skips weekends. Runs client-side to avoid cached stale dates from the CDN.
  var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function addWorkingDays(date, days) {
    var d = new Date(date.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return d;
  }
  function fmt(d) { return DAYS[d.getDay()] + ' ' + d.getDate() + ' ' + MONTHS[d.getMonth()]; }
  document.querySelectorAll('[data-delivery-min][data-delivery-max]').forEach(function (el) {
    var min = parseInt(el.getAttribute('data-delivery-min'), 10);
    var max = parseInt(el.getAttribute('data-delivery-max'), 10);
    var today = new Date();
    var start = addWorkingDays(today, min);
    var end = addWorkingDays(today, max);
    var label = el.querySelector('[data-delivery-label]');
    if (label) label.textContent = 'Free delivery: ' + fmt(start) + ' – ' + fmt(end);
  });

  // ========== PDP: gallery thumb → main image ==========
  document.querySelectorAll('[data-pdp-main-image]').forEach(function (main) {
    var thumbsContainer = main.parentElement.querySelector('.pdp__thumbs');
    if (!thumbsContainer) return;
    var thumbs = thumbsContainer.querySelectorAll('[data-thumb-idx]');
    var mainImg = main.querySelector('[data-pdp-main-img]') || main.querySelector('img');
    if (!mainImg) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-full-src');
        var srcset = thumb.getAttribute('data-full-srcset');
        var alt = thumb.getAttribute('data-full-alt');
        if (src) mainImg.src = src;
        if (srcset) mainImg.srcset = srcset;
        if (alt) mainImg.alt = alt;
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });

  // ========== PDP: variant / size chip selection ==========
  document.querySelectorAll('.pdp__form').forEach(function (form) {
    var dataEl = form.querySelector('[data-variant-data]');
    var variants = [];
    if (dataEl) {
      try { variants = JSON.parse(dataEl.textContent); } catch (err) { variants = []; }
    }
    var groups = Array.prototype.slice.call(form.querySelectorAll('[data-variant-group]'));

    function money(pence) {
      var s = (pence / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return '£' + s.replace(/\.00$/, '');
    }
    function selectedValues() {
      var vals = [];
      groups.forEach(function (g) {
        var active = g.querySelector('.variant-chip.is-active, .swatch.is-active');
        if (active) vals[parseInt(active.getAttribute('data-option-index'), 10)] = active.getAttribute('data-option-value');
      });
      return vals;
    }
    function findVariant(vals) {
      for (var i = 0; i < variants.length; i++) {
        var match = true;
        for (var j = 0; j < variants[i].options.length; j++) {
          if (vals[j] !== undefined && variants[i].options[j] !== vals[j]) { match = false; break; }
        }
        if (match) return variants[i];
      }
      return null;
    }
    function apply(variant) {
      if (!variant) return;
      var idInput = form.querySelector('[data-variant-id]');
      if (idInput) idInput.value = variant.id;
      var now = form.querySelector('[data-price-now]');
      if (now) now.textContent = money(variant.price);
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      var was = form.querySelector('[data-price-was]');
      if (was) {
        if (onSale) was.textContent = money(variant.compare_at_price);
        was.style.display = onSale ? '' : 'none';
      }
      var save = form.querySelector('[data-price-save]');
      if (save) {
        if (onSale) {
          var diff = variant.compare_at_price - variant.price;
          save.textContent = 'Save ' + money(diff) + ' (' + Math.round(diff * 100 / variant.compare_at_price) + '%)';
        }
        save.style.display = onSale ? '' : 'none';
      }
      var cta = form.querySelector('.pdp__cta-primary');
      if (cta) {
        cta.disabled = !variant.available;
        if (variant.available) cta.innerHTML = 'Add to basket · <span data-cta-price>' + money(variant.price) + '</span>';
        else cta.textContent = 'Sold out';
      }
      var stickyPrice = document.querySelector('[data-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = money(variant.price);
      var stickyBtn = document.querySelector('[data-pdp-sticky-add]');
      if (stickyBtn) { stickyBtn.disabled = !variant.available; stickyBtn.textContent = variant.available ? 'Add' : 'Sold out'; }
    }
    groups.forEach(function (group) {
      group.addEventListener('click', function (e) {
        var chip = e.target.closest('.variant-chip, .swatch');
        if (!chip || chip.classList.contains('is-disabled')) return;
        group.querySelectorAll('.variant-chip, .swatch').forEach(function (c) { c.classList.remove('is-active'); });
        chip.classList.add('is-active');
        apply(findVariant(selectedValues()));
      });
    });
  });

  // ========== PDP: feature hotspot tabs ==========
  document.querySelectorAll('[data-feature-tabs]').forEach(function (group) {
    var tabs = group.querySelectorAll('.feature-tab');
    var hotspots = document.querySelectorAll('[data-hotspot]');
    function activate(idx) {
      tabs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
      hotspots.forEach(function (h) {
        h.classList.toggle('is-active', h.getAttribute('data-hotspot') === String(idx + 1));
      });
    }
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { activate(i); });
    });
    hotspots.forEach(function (h) {
      h.addEventListener('click', function () {
        var idx = parseInt(h.getAttribute('data-hotspot'), 10) - 1;
        activate(idx);
      });
    });
  });

  // ========== FAQ accordion ==========
  document.querySelectorAll('.faq-item__q').forEach(function (q) {
    q.addEventListener('click', function () {
      q.parentElement.classList.toggle('is-open');
      var expanded = q.parentElement.classList.contains('is-open');
      q.setAttribute('aria-expanded', expanded);
    });
    q.setAttribute('tabindex', '0');
    q.setAttribute('role', 'button');
    q.setAttribute('aria-expanded', q.parentElement.classList.contains('is-open'));
    q.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); q.click(); }
    });
  });

  // ========== Article TOC auto-build ==========
  var tocList = document.querySelector('[data-toc]');
  var articleBody = document.querySelector('.article-body');
  if (tocList && articleBody) {
    var headings = articleBody.querySelectorAll('h2');
    if (headings.length < 2) {
      var tocAside = document.querySelector('.article-toc');
      if (tocAside) tocAside.style.display = 'none';
    } else {
      headings.forEach(function (h, i) {
        var id = h.id || ('sec-' + i + '-' + (h.textContent || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''));
        h.id = id;
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + id;
        a.textContent = h.textContent;
        li.appendChild(a);
        tocList.appendChild(li);
      });

      // Scroll-spy
      var tocLinks = tocList.querySelectorAll('a');
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            tocLinks.forEach(function (l) { l.classList.remove('is-active'); });
            var match = tocList.querySelector('a[href="#' + entry.target.id + '"]');
            if (match) match.classList.add('is-active');
          }
        });
      }, { rootMargin: '-20% 0px -70% 0px' });
      headings.forEach(function (h) { obs.observe(h); });
    }
  }

  // ========== Wishlist (local-storage stub; swap for real service later) ==========
  var WL_KEY = 'gs_wishlist';
  function getWishlist() { try { return JSON.parse(localStorage.getItem(WL_KEY) || '[]'); } catch (e) { return []; } }
  function setWishlist(arr) { localStorage.setItem(WL_KEY, JSON.stringify(arr)); }
  document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
    var id = btn.getAttribute('data-wishlist-toggle');
    if (getWishlist().indexOf(id) !== -1) btn.classList.add('is-active');
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var list = getWishlist();
      var idx = list.indexOf(id);
      if (idx === -1) { list.push(id); btn.classList.add('is-active'); }
      else { list.splice(idx, 1); btn.classList.remove('is-active'); }
      setWishlist(list);
    });
  });
})();
